import { z } from "zod";

export const ESPECIES = ["cao", "gato", "bovino", "equino"] as const;
export const Especie = z.enum(ESPECIES);
export type Especie = z.infer<typeof Especie>;
/** Itens que valem para qualquer espécie usam "todas". */
export const EspecieOuTodas = z.enum([...ESPECIES, "todas"]);

export const PERFIS = ["vet", "farmacia", "agro", "estudante"] as const;
export const Perfil = z.enum(PERFIS);
export type Perfil = z.infer<typeof Perfil>;

/**
 * Ref: o elo entre um número do app e a pesquisa.
 * `f` é a fonte ("C.F07"), `loc` o localizador dentro dela, `fato` o fato
 * conferido. Sem fato, a ref precisa estar marcada como pendente.
 * `cit` e `status` não são editados: a publicação os preenche a partir do fato.
 */
/** Id prefixado pelo arquivo da pesquisa: "C.F07", "E.N_IN26_2009", "B1.DOR-01". */
export const ID_PESQUISA = /^[A-Z][A-Z0-9]*\.[A-Za-z0-9_-]+$/;

export const Ref = z
  .object({
    f: z.string().regex(ID_PESQUISA, "id de fonte no formato C.F07"),
    loc: z.string(),
    fato: z.union([z.string().regex(ID_PESQUISA), z.array(z.string().regex(ID_PESQUISA)).min(1)]).optional(),
    pendente: z.boolean().optional(),
    cit: z.string().optional(),
    status: z.literal("nao_verificado").optional(),
  })
  .strict();
export type Ref = z.infer<typeof Ref>;
export const Refs = z.array(Ref);

export const Nivel = z.enum(["info", "warning", "danger"]);
/** O protótipo usa duas grafias de alerta; as duas continuam válidas. */
export const Alerta = z.union([
  z.object({ nivel: Nivel, texto: z.string(), refs: Refs.optional() }).strict(),
  z.object({ n: Nivel, t: z.string(), refs: Refs.optional() }).strict(),
]);
export type Alerta = z.infer<typeof Alerta>;
export const Alertas = z.array(Alerta);

export function normAlerta(a: Alerta): { nivel: z.infer<typeof Nivel>; texto: string; refs?: Ref[] } {
  return "nivel" in a ? a : { nivel: a.n, texto: a.t, refs: a.refs };
}
